import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BoxTab } from '../box-tab';

@Component({
  selector: 'rl-box-tab',
  templateUrl: './box-tab.component.html',
  styleUrls: ['./box-tab.component.scss', './box-tab.component-rtl.css'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class BoxTabComponent {

  @Input() tab : BoxTab;
  constructor() { }

  iconMap = {
    collection : 'fa-folder-open',
    file : 'fa-cloud-upload',
    librarysearch : 'fa-search-plus',
    resource : 'fa-align-justify',  
  };

  imgMap = {
    manualForm : '/leganto/bundles/build/assets/images/manual-form-icon.png',
    mendeley : "/leganto/bundles/build/assets/images/mendeley-logo.png",
    refworks : "/leganto/bundles/build/assets/images/rw-logo.png",
    zotero : "/leganto/bundles/build/assets/images/zotero-logo.png"
  };
}
